import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { SelectorComponent } from 'src/ca-shared/selector/selector.module';
import { Operators } from 'src/core/models/request/operator.enum';
import { CategoryGroupDto } from 'src/core/models/conversation/category/category-group.dto';
import { CategoryGroupSelectionConfigurationModel } from '../models/category-group-selection-configuration.model';

@Component({
  selector: 'ca-category-group-selection-panel',
  templateUrl: './category-group-selection-panel.component.html',
  styleUrls: ['./category-group-selection-panel.component.scss'],
  standalone: false,
})
export class CategoryGroupSelectionPanelComponent
  extends FilterPanelEditorComponent
  implements OnInit
{
  actualConfig: CategoryGroupSelectionConfigurationModel;

  _value: CategoryGroupDto[];
  categoryGroupSelectorOptions: any;

  @ViewChild(SelectorComponent, { read: SelectorComponent })
  categoryGroupSelector: SelectorComponent;

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as CategoryGroupSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this.editorForm.patchValue({
      editor: value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    private operators: Operators,
    protected fb: FormBuilder,
  ) {
    super(fb);

    this.categoryGroupSelectorOptions = {
      pageSize: 5,
      queryOperator: this.operators.Contains,
      queryField: 'quickSearchTerm',
      url: CategoryGroupDto.apiUrl,
      currentPage: 1,
      showSelections: false,
      showClearSelections: false,
      showClearSelectionLink: true,
      selectorPosition: 'Top',
    };

    this.editorForm.valueChanges.subscribe(val => {
      this._value = val.editor;
      this.onChange();
    });
  }

  ngOnInit(): void {}

  reload(): void {}

  reset(): void {}

  autoSelectFirstItem(): void {}

  init() {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.categoryGroupSelector.refresh();
    }
  }
}
